import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "./Reveal";
import { CHAPTERS } from "./data";

export const About = () => {
  const [active, setActive] = useState(0);
  const chapter = CHAPTERS[active];

  return (
    <section id="chi-siamo" data-testid="about-section" className="py-24 sm:py-32 lg:py-40 px-6 sm:px-12 lg:px-20 max-w-7xl mx-auto">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#C85A32] mb-4">Chi Siamo</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-[1.1] text-[#181817] max-w-2xl">
          Il nostro modo di lavorare, in tre capitoli
        </h2>
      </Reveal>
      <div className="mt-16 grid lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-20">
        <Reveal delay={0.1} className="flex flex-col">
          {CHAPTERS.map((c, i) => (
            <button
              key={c.num}
              data-testid={`chapter-tab-${c.num}`}
              onClick={() => setActive(i)}
              className={`group flex items-baseline gap-5 py-6 border-b border-[#E5E2DC] text-left transition-colors duration-300 ${
                active === i ? "text-[#181817]" : "text-[#6E6D69] hover:text-[#181817]"
              }`}
            >
              <span className={`font-mono text-xs tracking-[0.2em] ${active === i ? "text-[#C85A32]" : ""}`}>{c.num}</span>
              <span className="font-display text-2xl sm:text-3xl font-light">{c.title}</span>
              <span
                className={`ml-auto h-px self-center transition-all duration-500 ${
                  active === i ? "w-12 bg-[#C85A32]" : "w-0 bg-[#C5C2BA] group-hover:w-6"
                }`}
              />
            </button>
          ))}
        </Reveal>
        <Reveal delay={0.2}>
          <AnimatePresence mode="wait">
            <motion.div
              key={chapter.num}
              data-testid="chapter-detail"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -16 }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              className="bg-[#FFFFFF] border border-[#E5E2DC] rounded-sm p-8 sm:p-12"
            >
              <p className="font-mono text-xs tracking-[0.25em] text-[#C85A32] uppercase mb-6">Capitolo {chapter.num}</p>
              <blockquote className="font-display text-2xl sm:text-3xl font-light leading-snug text-[#181817]">
                “{chapter.quote}”
              </blockquote>
              <p className="mt-6 text-base text-[#181817]/80 leading-relaxed">{chapter.text}</p>
            </motion.div>
          </AnimatePresence>
          <Reveal delay={0.15} className="mt-12 flex items-center gap-6">
            <div className="w-14 h-14 rounded-full bg-[#EDE6DA] border border-[#E5E2DC] flex items-center justify-center overflow-hidden">
              <img src="/logo-mark.png" alt="Logo Furlan Print Copy" className="h-9 w-auto" />
            </div>
            <div>
              <p className="font-display text-lg text-[#181817]">Furlan Print Copy</p>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#6E6D69]">Paderno Dugnano — Milano e Provincia</p>
            </div>
          </Reveal>
        </Reveal>
      </div>
    </section>
  );
};
